import type {ISharedResource} from '../schema';

export const canManageSharedResource = (sharedResource?: ISharedResource) =>
	!!sharedResource && sharedResource.canManage;
